(function () {
  'use strict';

  var T = window.daytoxTracking || {};
  var dataLayer = (window.dataLayer = window.dataLayer || []);
  var CURRENCY = T.shopCurrency;
  var MARKET_PREFIX = 'shopify_DE_'; // change per market

  // ---- shared event-id helpers (defined in tracking-customer-data.liquid) ----
  var store = (window.temp_track_store = window.temp_track_store || {});
  store.event_id = store.event_id || {};
  function generateEventId(event) {
    return event + '_' + decodeURIComponent(window.location.pathname) + '_' + new Date().getTime();
  }
  store.generateEventId = store.generateEventId || generateEventId;

  function pushEvent(name, payload) {
    var id = generateEventId(name);
    store.event_id[name] = id;
    payload.event_id = id;
    dataLayer.push(payload);
    return id;
  }

  function fetchJSON(url) {
    return fetch(url, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }

  function shopifyId(productId, variantId) {
    return MARKET_PREFIX + productId + '_' + (variantId || '');
  }

  function clean(str) {
    return (str || '').toString().replace(/'/g, '');
  }

  function getPageType() { return T.pageType || 'Other'; }

  // Map a Shopify product/variant JSON object to a dataLayer product.
  function mapProduct(product, opts) {
    opts = opts || {};
    var variant = opts.variant || product.variants[0];
    return {
      name: clean(product.title),
      id: (variant && variant.id) || '',
      sku: (variant && variant.sku) || '',
      productId: product.id,
      variantId: (variant && variant.id) || '',
      shopifyId: shopifyId(product.id, variant && variant.id),
      price: product.price / 100,
      brand: clean(product.vendor),
      variant: (variant && clean(variant.title)) || '',
      position: opts.position,
      list: opts.list,
      category: opts.category,
      handle: product.handle
    };
  }

  // Map a /cart.js or cart-template line item.
  function mapCartItem(item, idx) {
    return {
      position: idx,
      id: item.variant_id,
      sku: item.sku,
      productId: item.product_id,
      variantId: item.variant_id,
      shopifyId: shopifyId(item.product_id, item.variant_id),
      name: clean(item.product_title || item.title),
      quantity: item.quantity,
      price: item.price / 100,
      brand: clean(item.vendor),
      variant: item.variant_title
    };
  }

  /* ============================================================
   * Page-view event (pageType)
   * ============================================================ */
  function trackPageView() {
    var map = {
      index: { event: 'HomeView', pageType: 'home' },
      collection: { pageType: 'category' },
      product: { pageType: 'product' },
      cart: { pageType: 'cart' },
      search: { pageType: 'searchresults' }
    };
    var key = T.searchTerms != null ? 'search' : T.template;
    var entry = map[key] || { pageType: 'other' };
    var payload = { pageType: entry.pageType, shopifyPageType: T.template };
    if (entry.event) {
      pushEvent(entry.event, { event: entry.event, pageType: entry.pageType, shopifyPageType: T.template });
    } else {
      dataLayer.push(payload);
    }
  }

  /* ============================================================
   * Cart summary (customerData-style cart push)
   * ============================================================ */
  function trackCartSummary() {
    if (!T.cart) return;
    dataLayer.push({
      cart: {
        total: T.cart.total,
        count: T.cart.count,
        products: T.cart.items
      }
    });
  }

  /* ============================================================
   * PRODUCT PAGE
   * ============================================================ */
  function getCurrentVariant(product, form, id) {
    var selectedId = id;
    if (selectedId === undefined) {
      var selects = form
        ? form.querySelectorAll('[name="id"]')
        : document.querySelectorAll('form[action^="/cart/add"] select[name="id"]');
      if (!selects.length) return product.variants[0];
      selectedId = selects[0].value;
    }
    if (!/^[0-9]+$/.test(selectedId)) return product.variants[0];
    return product.variants.filter(function (v) { return v.id == selectedId; })[0];
  }

  function pushDetailView(product, variant, category) {
    pushEvent('productDetailView', {
      event: 'productDetailView',
      ecommerce: {
        currencyCode: CURRENCY,
        detail: {
          products: [{
            name: clean(product.title),
            id: (variant && variant.id) || '',
            sku: (variant && variant.sku) || '',
            productId: product.id,
            variantId: (variant && variant.id) || '',
            shopifyId: shopifyId(product.id, variant && variant.id),
            price: product.price / 100,
            brand: clean(product.vendor),
            variant: (variant && clean(variant.title)) || '',
            category: category || undefined
          }]
        }
      }
    });
  }

  function pushVariantInfo(product, variant) {
    if (!variant) return;
    dataLayer.push({
      VariantCompareAtPrice: variant.compare_at_price / 100,
      VariantPrice: variant.price / 100,
      VariantInventoryQuantity: variant.inventory_quantity,
      shopifyProductId: shopifyId(product.id, variant.id)
    });
  }

  function initProductPage() {
    var product = T.product;
    if (!product) return;
    var category = T.collectionTitle || undefined;

    var variant = getCurrentVariant(product);
    pushVariantInfo(product, variant);
    pushDetailView(product, variant, category);

    // Variant change — read variant id from the URL after the click settles.
    document.querySelectorAll('.product__selectors input').forEach(function (el) {
      el.addEventListener('click', function () {
        setTimeout(function () {
          var match = window.location.href.match(/variant=([0-9]*)/);
          if (!match) return;
          var v = getCurrentVariant(product, undefined, match[1]);
          pushDetailView(product, v, category);
          pushVariantInfo(product, v);
        }, 400);
      });
    });

    // Add-to-cart on the product form(s).
    var forms = Array.prototype.slice.call(document.querySelectorAll('form[action^="/cart/add"]'));
    forms.forEach(function (form) {
      function handleAdd() {
        var v = getCurrentVariant(product, form);
        var qtyEl = document.querySelector('form[action*="cart/add"] [name*="quantity"]');
        pushEvent('addToCart', {
          event: 'addToCart',
          ecommerce: {
            currencyCode: (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.currency) || CURRENCY,
            add: {
              products: [{
                name: clean(product.title),
                id: (v && v.id) || '',
                sku: (v && v.sku) || '',
                productId: product.id,
                variantId: (v && v.id) || '',
                shopifyId: shopifyId(product.id, v && v.id),
                price: (v && v.price) / 100 || 0,
                brand: clean(product.vendor),
                variant: (v && clean(v.title)) || '',
                quantity: qtyEl ? Number(qtyEl.value) : 1,
                category: category || undefined
              }]
            }
          }
        });
      }

      var addButtons = form.querySelectorAll('[name="add"], [data-addtocart], [data-action*="add-to-cart"]');
      if (addButtons.length) {
        addButtons.forEach(function (btn) { btn.addEventListener('mousedown', handleAdd); });
      } else {
        form.addEventListener('submit', handleAdd);
      }
    });
  }

  /* ============================================================
   * CART PAGE
   * ============================================================ */
  function initCartPage() {
    if (T.template !== 'cart' || !T.cart) return;
    var items = T.cart.items.map(function (item, i) { return mapCartItem(item, i); });

    if (items.length) {
      var ids = items.length === 1 ? items[0].id : items.map(function (i) { return i.id; });
      var shopIds = items.length === 1 ? items[0].shopifyId : items.map(function (i) { return i.shopifyId; });
      dataLayer.push({ cartItems: ids, shopifyCartItemSkus: shopIds });
    }

    pushEvent('viewCart', {
      cartTotal: T.cart.total,
      event: 'viewCart',
      ecommerce: {
        currencyCode: CURRENCY,
        actionField: { list: 'Shopping Cart' },
        impressions: items
      }
    });

    // Remove-from-cart (quantity=0 links)
    document.querySelectorAll('a[href*="quantity=0"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var idx = Number(e.target.href.split('line=')[1].split('&')[0]) - 1;
        var removed = items.filter(function (i) { return i.position === idx; });
        pushEvent('removeFromCart', {
          event: 'removeFromCart',
          ecommerce: { remove: { products: removed } }
        });
      });
    });
  }

  /* ============================================================
   * SEARCH RESULTS
   * ============================================================ */
  function initSearchPage() {
    if (T.searchTerms == null) return;
    dataLayer.push({ event: 'SearchView', SearchTerms: T.searchTerms });

    var all = (T.searchResults || []).map(function (p, i) {
      return mapProduct(p, { position: i, list: 'Search Results' });
    });
    var visible = collectVisibleProducts(all, 36);
    pushEvent('searchResults', {
      event: 'searchResults',
      ecommerce: {
        currencyCode: CURRENCY,
        actionField: { list: 'Search Results' },
        impressions: visible
      }
    });
  }

  /* ============================================================
   * COLLECTION PAGE
   * ============================================================ */
  function initCollectionPage() {
    if (T.template !== 'collection') return;
    var title = T.collectionTitle || 'All Products';

    var all = (T.collectionProducts || []).map(function (p, i) {
      return mapProduct(p, { position: i, category: title, list: getPageType() });
    });

    var visible = collectVisibleProducts(all, 50, function (item, product) {
      bindGridAddToCart(item, product, title);
    });

    pushEvent('collectionView', {
      event: 'collectionView',
      collectionName: title,
      ecommerce: {
        currencyCode: CURRENCY,
        actionField: { list: title },
        impressions: visible
      }
    });
  }

  /* ============================================================
   * HOME PAGE (grid add-to-cart via per-product fetch)
   * ============================================================ */
  function initHomePage() {
    if (T.template !== 'index') return;
    document.querySelectorAll('a[href*="/products/"]').forEach(function (item) {
      if (item.dataset.trackatc === 'true') return;
      var btn = item.parentElement && item.parentElement.querySelector('button[data-cart-add]');
      if (!btn) return;

      var handle = lastPathSegment(item.href);
      fetchJSON('/products/' + handle + '.js').then(function (product) {
        var mapped = mapProduct(product, { list: getPageType() });
        btn.addEventListener('click', function () {
          mapped.quantity = 1;
          pushEvent('addToCart', {
            event: 'addToCart',
            ecommerce: {
              currencyCode: CURRENCY,
              actionField: { list: 'Collection Page' },
              add: { products: [mapped] }
            }
          });
        });
        item.setAttribute('data-trackatc', 'true');
      });
    });
  }

  /* ============================================================
   * /pages/<handle> product detection (e.g. landing pages)
   * ============================================================ */
  function initLandingPage() {
    if (window.location.href.indexOf('/pages/') === -1) return;
    var handle = lastPathSegment(window.location.pathname);
    fetchJSON('/products/' + handle + '.js').then(function (item) {
      var mapped = [mapProduct(item, {})];
      pushEvent('productDetailView', {
        event: 'productDetailView',
        ecommerce: { currencyCode: CURRENCY, detail: { products: mapped } }
      });
      var atc = document.querySelector('.gf_add-to-cart');
      if (!atc) return;
      atc.addEventListener('click', function () {
        var qtyEl = document.querySelector('input[name*="quantity"]');
        mapped[0].quantity = qtyEl && !isNaN(qtyEl.value) ? parseInt(qtyEl.value, 10) : 1;
        pushEvent('addToCart', {
          event: 'addToCart',
          ecommerce: { currencyCode: CURRENCY, add: { products: mapped } }
        });
      });
    }).catch(function () { /* not a product handle — ignore */ });
  }

  /* ============================================================
   * CART HOVER / CHECKOUT (live /cart.js)
   * ============================================================ */
  function fetchCartAndPush(eventName, extra) {
    return fetchJSON('/cart.js').then(function (cart) {
      if (!cart.items.length) return;
      var items = cart.items.map(function (item, i) { return mapCartItem(item, i); });
      var payload = {
        cartTotal: cart.total_price / 100,
        itemCount: cart.item_count,
        event: eventName,
        ecommerce: Object.assign({ currencyCode: CURRENCY }, extra, { impressions: items })
      };
      pushEvent(eventName, payload);
    });
  }

  function initCartButtons() {
    var cartBtns = Array.prototype.slice.call(document.querySelectorAll('[href*="/cart"]'));
    var hoverState = false;
    cartBtns.forEach(function (btn) {
      if (btn.id === 'cart_block') {
        btn.addEventListener('mouseover', function () {
          if (hoverState) return;
          hoverState = true;
          setTimeout(function () {
            fetchCartAndPush('viewCart', { actionField: { list: 'Shopping Cart' } });
          }, 500);
        });
        btn.addEventListener('mouseleave', function () { hoverState = false; });
      } else {
        btn.addEventListener('click', function () {
          fetchCartAndPush('viewCart', { actionField: { list: 'Shopping Cart' } });
        });
      }
    });

    var checkoutBtns = Array.prototype.slice.call(
      document.querySelectorAll('button[name*="checkout"], [class*="btn"][href*="checkout"]')
    );
    checkoutBtns.forEach(function (btn) {
      var evt = btn.tagName === 'BUTTON' ? 'click' : 'mousedown';
      btn.addEventListener(evt, function () {
        fetchJSON('/cart.js').then(function (cart) {
          if (!cart.items.length) return;
          var items = cart.items.map(function (item, i) { return mapCartItem(item, i); });
          pushEvent('checkout', {
            cartTotal: cart.total_price / 100,
            itemCount: cart.item_count,
            event: 'checkout',
            ecommerce: {
              currencyCode: CURRENCY,
              checkout: { actionField: { step: 1 }, products: items }
            }
          });
        });
      });
    });
  }

  /* ============================================================
   * PRODUCT CLICK (all listing links)
   * ============================================================ */
  function initProductClicks(allProducts) {
    document.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (!allProducts || !allProducts.length) return;
        var target = e.target.closest('a[href*="/products/"]');
        if (!target) return;
        var handle = lastPathSegment(target.href);
        var clicked = allProducts.filter(function (p) { return p.handle === handle; });
        if (!clicked[0]) return;
        var product = Object.assign({}, clicked[0]);
        var listName = product.category || getPageType();
        delete product.list; delete product.handle;
        pushEvent('productClick', {
          event: 'productClick',
          ecommerce: {
            currencyCode: CURRENCY,
            click: { actionField: { list: listName }, products: [product] }
          }
        });
      });
    });
  }

  /* ============================================================
   * Shared helpers
   * ============================================================ */
  function lastPathSegment(url) {
    var arr = url.split('/products/');
    return arr[arr.length - 1].replace(/\//g, '').split('?')[0];
  }

  // Match rendered product links against the Liquid product list, build impressions,
  // and optionally bind an add-to-cart handler per visible item.
  function collectVisibleProducts(allProducts, limit, onVisible) {
    var visible = [];
    Array.prototype.slice
      .call(document.querySelectorAll('a[href*="/products/"]'))
      .slice(0, limit)
      .forEach(function (item) {
        if (!allProducts.length) return;
        var handle = lastPathSegment(item.href);
        var match = allProducts.filter(function (p) { return p.handle === handle; });
        if (!match.length) return;
        if (visible.indexOf(match[0]) === -1) {
          visible.push(match[0]);
          if (onVisible) onVisible(item, match[0]);
        }
      });
    return visible;
  }

  function bindGridAddToCart(item, product, listName) {
    if (item.dataset.trackatc === 'true') return;
    var btn = item.parentElement && item.parentElement.querySelector('button[data-cart-add]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var p = Object.assign({}, product, { quantity: 1 });
      pushEvent('addToCart', {
        event: 'addToCart',
        ecommerce: {
          currencyCode: CURRENCY,
          actionField: { list: listName },
          add: { products: [p] }
        }
      });
    });
    item.setAttribute('data-trackatc', 'true');
  }

  /* ============================================================
   * Boot
   * ============================================================ */
  function init() {
    trackCartSummary();
    trackPageView();

    initProductPage();
    initCartPage();
    initSearchPage();
    initCollectionPage();
    initHomePage();
    initLandingPage();
    initCartButtons();

    // productClick uses whichever product list the current page produced.
    var list = (T.collectionProducts || T.searchResults || []).map(function (p, i) {
      return mapProduct(p, { position: i });
    });
    initProductClicks(list);
  }

  if (document.readyState === 'loading') {
    window.addEventListener('load', init);
  } else {
    init();
  }
})();
